// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__v9OZU","row":"Node_row__3FSl8","label":"Node_label__1FPIO","footer":"Node_footer__3zIHl"};